export const sjekkGateadresse = (firstAddress, secondAddress) =>
  firstAddress.gate === secondAddress.gate &&
  firstAddress.husnr === secondAddress.husnr &&
  firstAddress.bokstav === secondAddress.bokstav;

export const sjekkMatrikkeladresse = (firstMatrikkel, secondMatrikkel) =>
  firstMatrikkel.gardsnr === secondMatrikkel.gardsnr &&
  firstMatrikkel.bruksnr === secondMatrikkel.bruksnr &&
  firstMatrikkel.seksjonsnr === secondMatrikkel.seksjonsnr;

export const opprettVegadresse = (vegadresse) => {
  const tmp = vegadresse.split(',');

  return {
    gate: tmp[0].replace(/_/g, ' '),
    husnr: parseInt(tmp[1], 10),
    bokstav: tmp[2] ? tmp[2] : null,
  };
};

export const opprettMatrikkeladresse = (matrikkelstreng) => {
  const tmp = matrikkelstreng.split('.');

  const gbsNummer = tmp.map((m) => (m.length > 0 ? parseInt(m, 10) : undefined));

  if (gbsNummer.filter((n) => Number.isFinite(n)) < 2) {
    return null;
  }

  return {
    gardsnr: gbsNummer[0],
    bruksnr: gbsNummer[1],
    seksjonsnr: gbsNummer[2] ? gbsNummer[2] : null,
  };
};

export const settSammenEksternId = (eiendom) => {
  const { vegadresse } = eiendom.postadresser[0];
  const vegadr = `${vegadresse.gate.replace(/\s/g, '_')},${vegadresse.husnr || ''}${
    vegadresse.bokstav ? `,${vegadresse.bokstav}` : ''
  }`;
  return `:${vegadr}`;
};
